import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer, PURGE } from "redux-persist";
import { authPersist, statePersist } from "persist";
import authReducer from "store/auth/authSlice";
import settingReducer from "store/settings/settingSlice";
import stateReducer from "store/state/stateSlice";
import paperReducer from "store/papers/papersSlice";
import roundReducer from "store/round/roundSlice";
import voucherReducer from "store/vouchers/voucherSlice";
import customerReducer from "store/customers/customersSlice";
import branchReducer from "store/branch/branchSlice";
import userReducer from "store/users/userSlice";
import rolesReducer from "store/roles/roleSlice";
import holidayReducer from "store/holidays/holidaySlice";
import paymentReducer from "store/payments/paymentSlice";
import reportReducer from "store/reports/reportSlice";
import dashboardReducer from "store/dashboard/dashboardSlice";
import additionalPaperReducer from "store/additional-papers/additionalpapersSlice";
import deliveryReducer from "./delivery-fees/deliverySlice";
const appReducer = combineReducers({
  auth: persistReducer(authPersist, authReducer),
  state: persistReducer(statePersist, stateReducer),
  setting: settingReducer,
  paper: paperReducer,
  additionalPaper: additionalPaperReducer,
  rounds: roundReducer,
  voucher: voucherReducer,
  customer: customerReducer,
  branch: branchReducer,
  user: userReducer,
  role: rolesReducer,
  holiday: holidayReducer,
  payment: paymentReducer,
  report: reportReducer,
  dashboard: dashboardReducer,
  delivery: deliveryReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === PURGE) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
